import { defineComponent as _defineComponent } from 'vue'
export interface Props<T = unknown> {
  /** ... */
  column: TablePanel.Column<T>;
  /** ... */
  row: TablePanel.Row<T>;
}

interface Cell {
  value: string;
  classList: string[];
}


import { computed } from 'vue';
import type { TablePanel } from 'table-panel';

import { dateFilter } from '@filters/date';
import { stringify } from '@tools/stringify';
import { isBoolean, isString, isNumber } from '@tools/type-guards';
import * as currencies from '@utils/currencies';

declare module 'vue' {
  export interface Vue {
    TablePanelCell: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TablePanelCell' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    column: null,
    row: null
  },
  setup(__props: any) {

const props = __props as {
  /** ... */
  column: TablePanel.Column<T>;
  /** ... */
  row: TablePanel.Row<T>;
};

/**
 * `TablePanelCell` component properties.
 */


const blank = computed(() => !props.row);
const value = computed(() => props.row.values?.[props.column.key]);

const placeholder = computed(() => {
  let value: unknown;

  if (isString(props.column.placeholder)) {
    value = props.column.placeholder;
  } else if (props.column.placeholder) {
    value = props.column.placeholder(props.row);
  }

  return value ? stringify(value) : '--';
});

const cell = computed(() => {
  const cell: Cell = {
    value: '',
    classList: [`cell-${props.column.type ?? 'default'}`],
  };

  if (blank.value) return cell;

  if (props.column.type === 'currency' && isNumber(value.value)) {
    cell.value = currencies.format(value.value);
  } else if (props.column.type === 'date' && value.value) {
    cell.value = stringify(dateFilter(value.value as string, 'MM/dd/yyyy'));
  } else if (props.column.type === 'boolean' && isBoolean(value.value)) {
    cell.value = value.value ? 'Yes' : 'No';
  } else {
    cell.value = stringify(value.value);
  }

  if (props.column.type === 'percent' && cell.value) {
    cell.value += '%';
  }

  if (!cell.value) {
    cell.value = placeholder.value;
    cell.classList.push('cell-no-entry');
  }

  return cell;
});

return { __sfc: true,props, blank, value, placeholder, cell }
}

})